module.exports = __webpack_public_path__ + "img/Andorra.4130c7bd.svg";